import Swiper, {Pagination, Navigation} from "swiper";


const inspirationBlock = document.querySelectorAll('.layout-inspiration-block');

if (!_.isEmpty(inspirationBlock)) {
    Array.from(inspirationBlock).forEach(item => {
        // console.log(item);

        if (_.isNil(item.querySelector('.field--name-field-teasers'))) {
            return;
        }
        if(!_.isNil(item.querySelector('.show-in-rows'))){
            return;
        }

        let slidesPerViewDesktop = 3;
        // If item has class '4-in-a-row', then we don't want to initialize the swiper
        if(item.querySelector('.field--name-field-teasers').classList.contains('4-in-a-row')){
            slidesPerViewDesktop = 4;
        }


        item.querySelector('.field--name-field-teasers').classList.add('swiper-container');

        const nextBtn = item.querySelector('.swiper-button-next');
        const prevBtn = item.querySelector('.swiper-button-prev');

        const swiper = new Swiper(item.querySelector('.swiper-container'), {
            modules: [Navigation],
            createElements: true,
            slidesPerView: 1.25,
            spaceBetween: 16,
            navigation: (nextBtn || prevBtn) ? {
                nextEl: nextBtn,
                prevEl: prevBtn,
            } : false,
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                991: {
                    slidesPerView: slidesPerViewDesktop,
                    spaceBetween: 30,
                }
            }
        })
    })
}

const inspirationEventBlock = document.querySelectorAll('.layout-inspiration-block-events, .view-events.view-display-id-block_4');

if (!_.isEmpty(inspirationEventBlock)) {
    Array.from(inspirationEventBlock).forEach(item => {

        if (_.isNil(item.querySelector('.events-wrapper'))) {
            return;
        }

        item.querySelector('.events-wrapper').classList.add('swiper-container');

        const fieldItems = item.querySelectorAll('.events-wrapper .swiper-wrapper > .field__item, .events-wrapper .swiper-wrapper > .views-row');

        fieldItems.forEach(field => {
            field.classList.add('swiper-slide');
        });

        const swiperEvents = new Swiper(item.querySelector('.swiper-container'), {
            createElements: true,
            slidesPerView: 1.25,
            spaceBetween: 16,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                991: {
                    slidesPerView: 3
                },
                1199: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                }
            }
        })
    })
}

// const newsItems = document.querySelectorAll('.layout-news-items');
//
// if (!_.isEmpty(newsItems)) {
//     Array.from(newsItems).forEach(item => {
//
//         if (_.isNil(item.querySelector('.view-latest-news'))) {
//             return;
//         }
//
//         item.querySelector('.view-latest-news .view-content').classList.add('swiper-container');
//
//         const fieldItems = item.querySelectorAll('.view-latest-news .view-content > .views-row');
//
//         fieldItems.forEach(field => {
//             field.classList.add('swiper-slide');
//         });
//
//         const swiperEvents = new Swiper(item.querySelector('.swiper-container'), {
//             createElements: true,
//             slidesPerView: 1.25,
//             spaceBetween: 16,
//             pagination: {
//                 el: ".swiper-pagination",
//                 clickable: true,
//             },
//             breakpoints: {
//                 768: {
//                     slidesPerView: 2.5
//                 },
//                 991: {
//                     slidesPerView: 3,
//                     spaceBetween: 30,
//                 }
//             }
//         })
//     })
// }

// const instagramFeed = document.querySelector('.instagram-feed');
//
// if (!_.isNil(instagramFeed)  && !_.isNil(instagramFeed.querySelector('.swiper-container'))) {
//     const swiper = new Swiper(instagramFeed.querySelector('.swiper-container'), {
//         slidesPerView: 1.45,
//         spaceBetween: 0,
//         modules: [Pagination],
//         pagination: {
//             el: ".swiper-pagination",
//             clickable: true,
//         },
//         breakpoints: {
//             768: {
//                 slidesPerView: 4.25
//             },
//             991: {
//                 slidesPerView: 6,
//             }
//         }
//     })
// }